// extracted by mini-css-extract-plugin
export var grid = "HalfAndHalfHeader-module--grid--1A5k7";
export var verticalBleed = "HalfAndHalfHeader-module--vertical-bleed--1bB0z";
export var wistiaWrap = "HalfAndHalfHeader-module--wistia-wrap--2vTsL";
export var headingContent = "HalfAndHalfHeader-module--heading-content--2y_YA";